import { COREX_AML_FILES_QUERY, FEATURE_QUERY_ENABLED, Feature } from '@gig/magic-messages';

var isRedirectionFeatureEnabled = null;
var featureFlagPromise = null;
function initializeFeatureFlag() {
    if (featureFlagPromise) {
        return featureFlagPromise;
    }
    featureFlagPromise = window.queryBus
        .query(FEATURE_QUERY_ENABLED, Feature.REDIRECTION_TO_VERIFICATION_SECTION)
        .then(function (enabled) {
        isRedirectionFeatureEnabled = enabled !== null && enabled !== void 0 ? enabled : true;
        return isRedirectionFeatureEnabled;
    })
        .catch(function () {
        isRedirectionFeatureEnabled = true;
        return true;
    });
    return featureFlagPromise;
}
if (typeof window !== 'undefined' && window.queryBus) {
    initializeFeatureFlag();
}
function shouldBlockUser(compliance, documents) {
    var _a;
    if (isRedirectionFeatureEnabled === null) {
        initializeFeatureFlag();
        isRedirectionFeatureEnabled = true;
    }
    if (!isRedirectionFeatureEnabled) {
        return false;
    }
    var status = getComplianceStatus(compliance);
    if (status !== 'Failed' && status !== 'Pending') {
        return false;
    }
    var hasRequestedDocuments = (_a = documents === null || documents === void 0 ? void 0 : documents.some(function (document) { return document.verificationStatus === 'Requested'; })) !== null && _a !== void 0 ? _a : false;
    if (!hasRequestedDocuments) {
        return false;
    }
    return true;
}
function getComplianceStatus(compliance) {
    if (compliance.kycVerificationStatus === 'Verified' ||
        compliance.kycVerificationStatus === 'VerifiedPartial') {
        return compliance.kycVerificationStatus;
    }
    var statuses = [
        compliance.idVerificationStatus,
        compliance.addressVerificationStatus,
        compliance.sourceOfWealthVerificationStatus,
    ];
    if (statuses.includes('Failed')) {
        return 'Failed';
    }
    else if (statuses.includes('Pending')) {
        return 'Pending';
    }
    else if (statuses.includes('VerifiedPartial')) {
        return 'VerifiedPartial';
    }
    return 'Verified';
}
function fetchUserDocuments() {
    return window.queryBus.query(COREX_AML_FILES_QUERY);
}

export { fetchUserDocuments, getComplianceStatus, shouldBlockUser };
